import ThirdPartyIntegration from 'services/thirdPartyIntegrationService';

const normalizePositiveId = (value) => {
  const normalizedId = Number(value);
  if (Number.isNaN(normalizedId) || normalizedId <= 0) {
    return undefined;
  }
  return normalizedId;
};

const parseDateToTimestamp = (value) => {
  const timestamp = Date.parse(value || '');
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const pickNewestIntegration = (integrations = []) => {
  return [...integrations].sort((a, b) => {
    const aHasStation = a?.stationsId ? 1 : 0;
    const bHasStation = b?.stationsId ? 1 : 0;
    if (aHasStation !== bHasStation) {
      return bHasStation - aHasStation;
    }

    const updatedAtDiff = parseDateToTimestamp(b?.updatedAt) - parseDateToTimestamp(a?.updatedAt);
    if (updatedAtDiff !== 0) {
      return updatedAtDiff;
    }

    return (Number(b?.thirdPartyId) || 0) - (Number(a?.thirdPartyId) || 0);
  })[0];
};

export const getThirdPartyIdFromStationIntegrationList = async (partyCode) => {
  try {
    const response = await ThirdPartyIntegration.getConfigsTelegram({});
    const list = Array.isArray(response?.data) ? response.data : [];

    const matchedIntegrations = list.filter((item) =>
      item?.partyCode === partyCode &&
      item?.isDeleted !== 1 &&
      item?.isHidden !== 1
    );

    const newestIntegration = pickNewestIntegration(matchedIntegrations);
    const resolvedId = normalizePositiveId(newestIntegration?.thirdPartyId);

    if (resolvedId !== undefined) {
      return resolvedId;
    }
  } catch (error) {
  }

  return undefined;
};
